var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDeviceTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3059",
    "data-name": "Rectangle 3059",
    width: 24,
    height: 24,
    transform: "translate(16292.5 1488)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_device_trust",
    transform: "translate(-16292.5 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8904",
    "data-name": "Group 8904",
    transform: "translate(16292 1489.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices-svgrepo-com_3_",
    "data-name": "devices-svgrepo-com (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_244",
    "data-name": "Union 244",
    d: "M5.5,20.662c.075-.464.357-1.005.9-1.005a.876.876,0,0,1,.1.005h2v-2h-7c-1,0-1-1.063-1-2v-14c0-.938,0-2,1-2h11V0h9.723A1.779,1.779,0,0,1,24,1.777V15.988a1.779,1.779,0,0,1-1.777,1.777H15.117V19.54H17.5a1.083,1.083,0,0,1,.121-.006,1.061,1.061,0,0,1,1.051.895,1.061,1.061,0,0,1-1.051.9,1.084,1.084,0,0,1-.121-.007h-5v.346h-6a.892.892,0,0,1-.1.005C5.856,21.668,5.575,21.126,5.5,20.662Zm16.723-4.675V1.777H11.684V1.662H1.5v14h11v.325Z",
    transform: "translate(0 0)",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_165",
    "data-name": "Subtraction 165",
    d: "M4.583,11.425a1.143,1.143,0,0,1-.5-.078c-.668-.4-4-2.519-4-5v-5c0-.227,3.96-.992,4-1,.207.032,5,.777,5,1v5c0,2.279-2.887,4.382-4,5A1.143,1.143,0,0,1,4.583,11.425Zm-.5-4.078,0,0c-.022.025-.024.036-.022.041s.008.005.012.005c.021,0,.059-.02.059-.033s0-.008-.011-.01a.121.121,0,0,0-.037,0l3-3a1,1,0,0,0,0-1,.678.678,0,0,0-.466-.134.967.967,0,0,0-.534.134l-2,3-1-1c-.033-.037-.13-.056-.289-.056-.186,0-.418.025-.571.042l-.14.014C2.1,5.322,2.106,5.3,2.1,5.3a.013.013,0,0,0-.012-.006.088.088,0,0,0-.055.029c-.006.007-.008.013-.006.018s.017.012.039.012h.015a.984.984,0,0,0,0,1l1,1c.03.032.118.048.271.048s.372-.019.524-.032c.093-.008.166-.015.2-.015Z",
    transform: "translate(7.417 3.315)",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceTrust);
export default __webpack_public_path__ + "static/media/ic_device_trust.07a235764f29b18da7e5b12426851cfa.svg";
export { ForwardRef as ReactComponent };